import Vue from 'vue'
import moment from 'moment'

Vue.prototype.$moment = moment

export default {}



// WEBPACK FOOTER //
// ./src/plugins/moment.js